import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ProductGate } from '@bloo-team/core-shell'

/**
 * Datafabric layout: the entitlement gate for every /fabric/* screen (D4).
 * One check covers all deep links into the product; unentitled sessions get
 * the guard page inside the shell, entitled ones never notice this route.
 */
function FabricLayout() {
  const { clusterId, scopeId } = Route.useParams()
  return (
    <ProductGate product="fabric" clusterId={clusterId} scopeId={scopeId}>
      <Outlet />
    </ProductGate>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/fabric')({ component: FabricLayout })
